import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeMPTEntity } from "../Entity/TreeNodeMPTEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicinalProductsMPT extends Art57NodeList{

    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent: any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Medicinal Product Types (${items?items.length:'-'})`);
        this.parent = parent;
        this.labelNodeName = 'Medicinal Product Types'
        this.items = items;
        this.cloningNode = cloningNode;

        if (this.cloningNode) {
          return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeMPTEntity(injector,item.producttypecode.name,this,item));
        }
    }

    override getHeaders(): string[] {
        return ['Medicinal Product Type'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsMPT = new TreeNodeMedicinalProductsMPT(
        this.ioc!,
        newParent,
        true,
        this.items
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }
    
    
}